document.addEventListener('DOMContentLoaded', () => {
  kitUploadSetup();

  const kitViewButtons = document.querySelectorAll('.finished-kits__kit-view');
  const kitViews = document.querySelectorAll('.finished-kits-modal__grid');
  const cards = document.querySelectorAll('.finished-kits-modal__card');

  const searchInput = document.querySelector('#finishedKitsSearch');
  const noResults = document.querySelector('#noResultsMessage');
  const footerButton = document.querySelector('.finished-kits-modal__footer .button--primary');
  const footerMessage = document.querySelector('.finished-kits-modal__footer p');

  let activeButton = document.querySelector('[kit-value="userKits"]');
  let selectedCard = null;
  let currentStep = 'select';
  let selectedFile = null;
  let isUploading = false;
  let uploadTriggered = false;

  const uploadKitModal = document.querySelector('.finished-kits-modal');
  const uploadModal = document.querySelector('.finished-kits-modal__upload');
  const kitSelectModal = document.querySelector('.finished-kits-modal__main');

  const openUploadModalButton = document.querySelector('#openUploadModal');

  if (openUploadModalButton && uploadKitModal) {
    openUploadModalButton.addEventListener('click', () => {
      uploadKitModal.style.display = 'block';
      document.documentElement.classList.add('modal-open');
      document.body.classList.add('modal-open');
      document.body.style.overflow = 'hidden';
    });
  }

  const closeModalButton = document.querySelector('.finished-kits-modal__close');
  if (closeModalButton) {
    closeModalButton.addEventListener('click', () => {
      uploadKitModal.style.display = 'none';
      document.documentElement.classList.remove('modal-open');
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
    });
  }

  /* ------------------------
     Card selection
  ------------------------ */

  cards.forEach((card) => {
    card.addEventListener('click', () => selectKit(card));
  });

  function selectKit(card) {
    if (selectedCard && selectedCard !== card) {
      selectedCard.classList.remove('selected');
    }

    selectedCard = card;
    card.classList.add('selected');

    footerButton.classList.remove('disabled');
  }

  footerButton.addEventListener('click', async () => {
    if (footerButton.classList.contains('disabled')) return;
    if (isUploading) return;

    if (currentStep === 'select') {
      if (!selectedCard) return;

      currentStep = 'upload';
      footerMessage.textContent = 'Step 2 of 2';
      uploadModal.style.display = 'block';
      kitSelectModal.style.display = 'none';
      if (searchInput) searchInput.style.display = 'none';

      if (!selectedFile) {
        footerButton.classList.add('disabled');
      }
      return;
    }

    if (currentStep === 'upload') {
      if (!selectedCard || !selectedFile) return;
      if (uploadTriggered) return;

      const customerId = document.body.dataset.customerId;
      const productId = selectedCard.dataset.productId;
      if (!productId) return;

      uploadTriggered = true;
      isUploading = true;
      footerButton.classList.add('disabled');
      const originalText = footerButton.textContent;
      footerButton.textContent = 'Uploading...';

      try {
        await uploadFinishedKit(selectedFile, customerId, productId);

        setTimeout(() => {
          footerButton.textContent = 'Uploaded';
          window.location.reload();
        }, 5000);
      } catch (e) {
        footerButton.textContent = originalText;
        footerButton.classList.remove('disabled');
        uploadTriggered = false;
        alert('Upload failed. Please try again.');
        console.error(e);
      } finally {
        isUploading = false;
      }
    }
  });

  /* ------------------------
     Search
  ------------------------ */

  if (searchInput) {
    searchInput.addEventListener('input', searchKits);
  }

  function searchKits(e) {
    const query = e.target.value.toLowerCase().trim();
    let visibleCount = 0;

    cards.forEach((card) => {
      const title = card.dataset.title?.toLowerCase() || '';

      if (title.includes(query)) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    noResults.style.display = visibleCount === 0 ? 'block' : 'none';
  }

  /* ------------------------
     Kit view toggle
  ------------------------ */

  kitViewButtons.forEach((button) => {
    button.addEventListener('click', () => {
      activeButton?.classList.remove('active');
      button.classList.add('active');
      activeButton = button;

      const selectedKitValue = button.getAttribute('kit-value');

      kitViews.forEach((view) => {
        view.classList.toggle('active', view.id === selectedKitValue);
      });
    });
  });

  /* ------------------------
     Upload logic
  ------------------------ */

  async function uploadFinishedKit(file, customerId, productId) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('customer_id', customerId);
    formData.append('product_id', productId);
    formData.append('social_proof_title', document.body.dataset.customerName || 'Finished By Customer');
    formData.append('product_title', selectedCard.dataset.title);

    await fetch('https://eoffzm5jtotswu5.m.pipedream.net', {
      method: 'POST',
      body: formData,
    });
  }

  function kitUploadSetup() {
    const MAX_FILE_SIZE = 20 * 1024 * 1024;
    const MAX_IMAGE_MEGAPIXELS = 25;
    const validTypes = ['image/jpeg', 'image/png'];

    const uploadButton = document.querySelector('#uploadFinishedKit');
    const fileInput = document.querySelector('#finishedKitFileInput');
    const fileNameWrapper = document.querySelector('.finished-kits-modal__upload-filename-wrapper');
    const fileNameText = document.querySelector('.finished-kits-modal__upload-filename');
    const fileSizeText = document.querySelector('.finished-kits-modal__upload-filesize');

    const removeFileButton = document.querySelector('#removeFile');

    if (!uploadButton || !fileInput) return;

    uploadButton.addEventListener('click', () => fileInput.click());

    if (removeFileButton) {
      removeFileButton.addEventListener('click', (e) => {
        e.preventDefault();
        selectedFile = null;
        fileInput.value = '';
        uploadButton.disabled = false;
        if (fileNameWrapper) fileNameWrapper.style.display = 'none';
        if (fileNameText) fileNameText.textContent = '';
        if (fileSizeText) fileSizeText.textContent = '';

        if (currentStep === 'upload') {
          footerButton.classList.add('disabled');
          footerButton.textContent = 'Upload';
        }
      });
    }

    fileInput.addEventListener('change', async () => {
      const file = fileInput.files[0];
      if (!file) return;

      if (!validTypes.includes(file.type)) {
        alert('Only JPEG and PNG files are allowed.');
        fileInput.value = '';
        return;
      }

      if (file.size > MAX_FILE_SIZE) {
        alert('File must be under 20MB.');
        fileInput.value = '';
        return;
      }

      const objectUrl = URL.createObjectURL(file);
      try {
        const img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = objectUrl;
        });

        const megapixels = (img.naturalWidth * img.naturalHeight) / 1000000;
        if (megapixels > MAX_IMAGE_MEGAPIXELS) {
          alert(`Image is too large. Please upload an image under ${MAX_IMAGE_MEGAPIXELS} megapixels.`);
          selectedFile = null;
          fileInput.value = '';
          if (fileNameWrapper) fileNameWrapper.style.display = 'none';
          return;
        }

        selectedFile = file;
        if (fileNameWrapper) fileNameWrapper.style.display = 'flex';
        if (fileNameText) fileNameText.textContent = file.name;
        if (fileSizeText) fileSizeText.textContent = `(${formatFileSize(file.size)})`;

        if (currentStep === 'upload') {
          footerButton.classList.remove('disabled');
        }
      } catch (error) {
        alert('Invalid image file.');
        fileInput.value = '';
      } finally {
        URL.revokeObjectURL(objectUrl);
      }
    });
  }

  function formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

});
